// AUTO-GENERATED by scripts/generate-docs-index.mjs. Do not edit by hand.

import raw0 from "../../docs/ABC_CLASSIFICATION.md?raw"
import raw1 from "../../docs/ACTIVATED_FROM.md?raw"
import raw2 from "../../docs/adr/0001-in-house-feature-flags.md?raw"
import raw3 from "../../docs/AG_GRID.md?raw"
import raw4 from "../../docs/AI_MISTAKES.md?raw"
import raw5 from "../../docs/ALLOCATION_PLANNING_TERMINOLOGY.md?raw"
import raw6 from "../../docs/AMPLITUDE.md?raw"
import raw7 from "../../docs/artifacts/ALLOCATION_PLANNING_DESIGN.html?raw"
import raw8 from "../../docs/artifacts/ALLOCATION_PLANNING_SCHEMA.html?raw"
import raw9 from "../../docs/artifacts/OUTBOUND_EXPORT_SERVICE.html?raw"
import raw10 from "../../docs/artifacts/VIEW_ACCESS_SURFACES.html?raw"
import raw11 from "../../docs/AUTH0.md?raw"
import raw12 from "../../docs/AVAILABILITY.md?raw"
import raw13 from "../../docs/BRANCH_PR_NAMING.md?raw"
import raw14 from "../../docs/CACHING.md?raw"
import raw15 from "../../docs/CLOSING_STOCK.md?raw"
import raw16 from "../../docs/CODE_QUALITY.md?raw"
import raw17 from "../../docs/COLLECTIONS.md?raw"
import raw18 from "../../docs/COLUMN_NAMING.md?raw"
import raw19 from "../../docs/CONTRIBUTING.md?raw"
import raw20 from "../../docs/DATA_DIFF_INVESTIGATION.md?raw"
import raw21 from "../../docs/DATA_SYNC.md?raw"
import raw22 from "../../docs/DATABASES.md?raw"
import raw23 from "../../docs/DATE_HANDLING.md?raw"
import raw24 from "../../docs/DEMO_ENVIRONMENT.md?raw"
import raw25 from "../../docs/DOCUMENT_COMMENTS.md?raw"
import raw26 from "../../docs/ERP_CONTROLLED_FIELDS.md?raw"
import raw27 from "../../docs/FEATURE_FLAGS.md?raw"
import raw28 from "../../docs/FORECAST_ALERTS.md?raw"
import raw29 from "../../docs/GRAFANA.md?raw"
import raw30 from "../../docs/GROSS_SALES.md?raw"
import raw31 from "../../docs/HAKI_ACTIONS.md?raw"
import raw32 from "../../docs/HAKI_TILE_REPRODUCIBILITY.md?raw"
import raw33 from "../../docs/HAKI_TOOLS.md?raw"
import raw34 from "../../docs/helix/BASELINE.md?raw"
import raw35 from "../../docs/helix/DECISIONS.md?raw"
import raw36 from "../../docs/helix/FASHION.md?raw"
import raw37 from "../../docs/helix/FORECAST_ENGINE.md?raw"
import raw38 from "../../docs/helix/NOOS_LIFECYCLE.md?raw"
import raw39 from "../../docs/helix/NOOS_PLAN_PERIOD.md?raw"
import raw40 from "../../docs/helix/README.md?raw"
import raw41 from "../../docs/helix/SALES_TREND.md?raw"
import raw42 from "../../docs/IMAGE.md?raw"
import raw43 from "../../docs/INBOX_RECOMMENDATIONS.md?raw"
import raw44 from "../../docs/INGESTION_EVENTS.md?raw"
import raw45 from "../../docs/ingestion/BQ_TO_POSTGRES.md?raw"
import raw46 from "../../docs/ingestion/COMPANY_CONFIG.md?raw"
import raw47 from "../../docs/ingestion/HAKIO_META.md?raw"
import raw48 from "../../docs/ingestion/INTEGRATIONS.md?raw"
import raw49 from "../../docs/ingestion/PIPELINE_OVERVIEW.md?raw"
import raw50 from "../../docs/ingestion/README.md?raw"
import raw51 from "../../docs/ingestion/VIEW_CONTRACT.md?raw"
import raw52 from "../../docs/JSON_BLOB_VERSIONING.md?raw"
import raw53 from "../../docs/LINT_FEEDBACK.md?raw"
import raw54 from "../../docs/LISTEN_NOTIFY.md?raw"
import raw55 from "../../docs/LOGGING.md?raw"
import raw56 from "../../docs/MIGRATION_TESTER_TELEMETRY.md?raw"
import raw57 from "../../docs/MULTI_USER_SYNC.md?raw"
import raw58 from "../../docs/NPI_DEMAND_SIMULATION.md?raw"
import raw59 from "../../docs/NPI_FORECAST.md?raw"
import raw60 from "../../docs/NPI_MATCHING.md?raw"
import raw61 from "../../docs/ORCA.md?raw"
import raw62 from "../../docs/PATTERNS.md?raw"
import raw63 from "../../docs/perf/POSTGRES_PROD_PARITY.md?raw"
import raw64 from "../../docs/perf/TABLE_BENCHMARK.md?raw"
import raw65 from "../../docs/PLV8.md?raw"
import raw66 from "../../docs/PREORDER_HANDLING.md?raw"
import raw67 from "../../docs/REACT_QUERY.md?raw"
import raw68 from "../../docs/REPLACEMENT_LINKS.md?raw"
import raw69 from "../../docs/RETURN_FORECAST_LOGIC.md?raw"
import raw70 from "../../docs/SERVER_ARCHITECTURE.md?raw"
import raw71 from "../../docs/SKU_SPLIT.md?raw"
import raw72 from "../../docs/STYLING.md?raw"
import raw73 from "../../docs/SUPPLY_PLAN.md?raw"
import raw74 from "../../docs/TEMPORAL_TABLES.md?raw"
import raw75 from "../../docs/TESTING.md?raw"
import raw76 from "../../docs/TRACING.md?raw"

export const rawDocs: Record<string, string> = {
  "ABC_CLASSIFICATION.md": raw0,
  "ACTIVATED_FROM.md": raw1,
  "adr/0001-in-house-feature-flags.md": raw2,
  "AG_GRID.md": raw3,
  "AI_MISTAKES.md": raw4,
  "ALLOCATION_PLANNING_TERMINOLOGY.md": raw5,
  "AMPLITUDE.md": raw6,
  "artifacts/ALLOCATION_PLANNING_DESIGN.html": raw7,
  "artifacts/ALLOCATION_PLANNING_SCHEMA.html": raw8,
  "artifacts/OUTBOUND_EXPORT_SERVICE.html": raw9,
  "artifacts/VIEW_ACCESS_SURFACES.html": raw10,
  "AUTH0.md": raw11,
  "AVAILABILITY.md": raw12,
  "BRANCH_PR_NAMING.md": raw13,
  "CACHING.md": raw14,
  "CLOSING_STOCK.md": raw15,
  "CODE_QUALITY.md": raw16,
  "COLLECTIONS.md": raw17,
  "COLUMN_NAMING.md": raw18,
  "CONTRIBUTING.md": raw19,
  "DATA_DIFF_INVESTIGATION.md": raw20,
  "DATA_SYNC.md": raw21,
  "DATABASES.md": raw22,
  "DATE_HANDLING.md": raw23,
  "DEMO_ENVIRONMENT.md": raw24,
  "DOCUMENT_COMMENTS.md": raw25,
  "ERP_CONTROLLED_FIELDS.md": raw26,
  "FEATURE_FLAGS.md": raw27,
  "FORECAST_ALERTS.md": raw28,
  "GRAFANA.md": raw29,
  "GROSS_SALES.md": raw30,
  "HAKI_ACTIONS.md": raw31,
  "HAKI_TILE_REPRODUCIBILITY.md": raw32,
  "HAKI_TOOLS.md": raw33,
  "helix/BASELINE.md": raw34,
  "helix/DECISIONS.md": raw35,
  "helix/FASHION.md": raw36,
  "helix/FORECAST_ENGINE.md": raw37,
  "helix/NOOS_LIFECYCLE.md": raw38,
  "helix/NOOS_PLAN_PERIOD.md": raw39,
  "helix/README.md": raw40,
  "helix/SALES_TREND.md": raw41,
  "IMAGE.md": raw42,
  "INBOX_RECOMMENDATIONS.md": raw43,
  "INGESTION_EVENTS.md": raw44,
  "ingestion/BQ_TO_POSTGRES.md": raw45,
  "ingestion/COMPANY_CONFIG.md": raw46,
  "ingestion/HAKIO_META.md": raw47,
  "ingestion/INTEGRATIONS.md": raw48,
  "ingestion/PIPELINE_OVERVIEW.md": raw49,
  "ingestion/README.md": raw50,
  "ingestion/VIEW_CONTRACT.md": raw51,
  "JSON_BLOB_VERSIONING.md": raw52,
  "LINT_FEEDBACK.md": raw53,
  "LISTEN_NOTIFY.md": raw54,
  "LOGGING.md": raw55,
  "MIGRATION_TESTER_TELEMETRY.md": raw56,
  "MULTI_USER_SYNC.md": raw57,
  "NPI_DEMAND_SIMULATION.md": raw58,
  "NPI_FORECAST.md": raw59,
  "NPI_MATCHING.md": raw60,
  "ORCA.md": raw61,
  "PATTERNS.md": raw62,
  "perf/POSTGRES_PROD_PARITY.md": raw63,
  "perf/TABLE_BENCHMARK.md": raw64,
  "PLV8.md": raw65,
  "PREORDER_HANDLING.md": raw66,
  "REACT_QUERY.md": raw67,
  "REPLACEMENT_LINKS.md": raw68,
  "RETURN_FORECAST_LOGIC.md": raw69,
  "SERVER_ARCHITECTURE.md": raw70,
  "SKU_SPLIT.md": raw71,
  "STYLING.md": raw72,
  "SUPPLY_PLAN.md": raw73,
  "TEMPORAL_TABLES.md": raw74,
  "TESTING.md": raw75,
  "TRACING.md": raw76,
}

export type DocCommit = {
  hash: string
  date: string
  author: string
  message: string
}

export const docHistory: Record<string, DocCommit[]> = {
  "ABC_CLASSIFICATION.md": [],
  "ACTIVATED_FROM.md": [],
  "adr/0001-in-house-feature-flags.md": [],
  "AG_GRID.md": [],
  "AI_MISTAKES.md": [],
  "ALLOCATION_PLANNING_TERMINOLOGY.md": [],
  "AMPLITUDE.md": [],
  "artifacts/ALLOCATION_PLANNING_DESIGN.html": [],
  "artifacts/ALLOCATION_PLANNING_SCHEMA.html": [],
  "artifacts/OUTBOUND_EXPORT_SERVICE.html": [],
  "artifacts/VIEW_ACCESS_SURFACES.html": [],
  "AUTH0.md": [],
  "AVAILABILITY.md": [],
  "BRANCH_PR_NAMING.md": [],
  "CACHING.md": [],
  "CLOSING_STOCK.md": [],
  "CODE_QUALITY.md": [],
  "COLLECTIONS.md": [],
  "COLUMN_NAMING.md": [],
  "CONTRIBUTING.md": [],
  "DATA_DIFF_INVESTIGATION.md": [],
  "DATA_SYNC.md": [],
  "DATABASES.md": [],
  "DATE_HANDLING.md": [],
  "DEMO_ENVIRONMENT.md": [],
  "DOCUMENT_COMMENTS.md": [],
  "ERP_CONTROLLED_FIELDS.md": [],
  "FEATURE_FLAGS.md": [],
  "FORECAST_ALERTS.md": [],
  "GRAFANA.md": [],
  "GROSS_SALES.md": [],
  "HAKI_ACTIONS.md": [],
  "HAKI_TILE_REPRODUCIBILITY.md": [],
  "HAKI_TOOLS.md": [],
  "helix/BASELINE.md": [],
  "helix/DECISIONS.md": [],
  "helix/FASHION.md": [],
  "helix/FORECAST_ENGINE.md": [],
  "helix/NOOS_LIFECYCLE.md": [],
  "helix/NOOS_PLAN_PERIOD.md": [],
  "helix/README.md": [],
  "helix/SALES_TREND.md": [],
  "IMAGE.md": [],
  "INBOX_RECOMMENDATIONS.md": [],
  "INGESTION_EVENTS.md": [],
  "ingestion/BQ_TO_POSTGRES.md": [],
  "ingestion/COMPANY_CONFIG.md": [],
  "ingestion/HAKIO_META.md": [],
  "ingestion/INTEGRATIONS.md": [],
  "ingestion/PIPELINE_OVERVIEW.md": [],
  "ingestion/README.md": [],
  "ingestion/VIEW_CONTRACT.md": [],
  "JSON_BLOB_VERSIONING.md": [],
  "LINT_FEEDBACK.md": [],
  "LISTEN_NOTIFY.md": [],
  "LOGGING.md": [],
  "MIGRATION_TESTER_TELEMETRY.md": [],
  "MULTI_USER_SYNC.md": [],
  "NPI_DEMAND_SIMULATION.md": [],
  "NPI_FORECAST.md": [],
  "NPI_MATCHING.md": [],
  "ORCA.md": [],
  "PATTERNS.md": [],
  "perf/POSTGRES_PROD_PARITY.md": [],
  "perf/TABLE_BENCHMARK.md": [],
  "PLV8.md": [],
  "PREORDER_HANDLING.md": [],
  "REACT_QUERY.md": [],
  "REPLACEMENT_LINKS.md": [],
  "RETURN_FORECAST_LOGIC.md": [],
  "SERVER_ARCHITECTURE.md": [],
  "SKU_SPLIT.md": [],
  "STYLING.md": [],
  "SUPPLY_PLAN.md": [],
  "TEMPORAL_TABLES.md": [],
  "TESTING.md": [],
  "TRACING.md": [],
}
